import { ClimateAction } from "@/domain/climate-action/models/climate-action";
import { ColumnDef } from "@tanstack/react-table";

import { ClimateActionListCellProgress } from "../../climate-action-list-main-view/climate-action-simple-list-view/cells/climate-action-list-progress-cell";
import { ClimateActionListColumnHeader } from "../../climate-action-list-main-view/climate-action-simple-list-view/headers/climate-action-list-column-header";
import { ClimateActionColumnConfiguration } from "../column-definition-type";

interface ProgressColumnDefinitionProps {
  workspaceId: string;
  columnId: string;
  orderValue: number;
}

export const ProgressColumnDefinition = ({
  columnId,
  orderValue,
}: ProgressColumnDefinitionProps): ClimateActionColumnConfiguration => {
  return {
    columnId: columnId,
    getDefaultVisibilityState: () => true,
    getDisplayValue: () => "Fortschritt",
    getOrderValue: () => orderValue, // prefix with 100, 200, 300 to assign to sections
    getColumnDef: (): ColumnDef<ClimateAction> => {
      return {
        id: columnId,
        accessorKey: columnId, // key needed to enable sorting / filtering
        enableHiding: true,
        enableSorting: true,
        enableColumnFilter: false,
        sortingFn: (rowA, rowB) => {
          if (rowA.original.keyResult && !rowB.original.keyResult) {
            return 1;
          }
          if (rowB.original.keyResult && !rowA.original.keyResult) {
            return -1;
          }

          if (!rowA.original.keyResult) {
            return 0;
          }
          if (!rowB.original.keyResult) {
            return 0;
          }

          const divisorA = rowA.original.keyResult.targetValue - rowA.original.keyResult.initialValue;
          const progressA =
            divisorA === 0
              ? 0
              : (rowA.original.keyResult.currentValue - rowA.original.keyResult.initialValue) / divisorA;

          const divisorB = rowB.original.keyResult.targetValue - rowB.original.keyResult.initialValue;
          const progressB =
            divisorA === 0
              ? 0
              : (rowB.original.keyResult.currentValue - rowB.original.keyResult.initialValue) / divisorB;

          if (progressA > progressB) {
            return 1;
          }
          if (progressA < progressB) {
            return -1;
          }

          return 0;
        },
        size: 1, // set to 1 instead to 0 for it to work in Safari
        header: ({ column }) => (
          <ClimateActionListColumnHeader column={column} title="" className="px-1 text-xs font-normal" />
        ),
        cell: ({ row }) => <ClimateActionListCellProgress row={row} className="mx-2" />,
      };
    },
    getDisplayView: () => <></>,
    getConfigurationView: (_onFinished: () => void) => <></>,
    getConfigurationViewType: () => "none",
    getFilterPaneView: () => <></>,
  };
};
